import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-modal";
import MealsStructure from "../../diet/meal/MealsStructure";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import { fetchGTPTtrainersStats } from "../../../redux/reducers/apiSlice";
import {
  getCardIcon,
  getCardLabel,
  getCardValue,
} from "../../common-data/Conversions";
import CommonStatCard from "./CommonStatCard";
import PTFlowStatCardDetails from "./PTFlowStatCardDetails";

const PT_TRAINER_INFO_ORDER = [
  "total_pt_trainer",
  "pt_trainer_with_pt",
  "pt_trainer_without_pt",
];

const PTFlowTrainerInfoStats = ({
  userInfoData,
  prevAllFilters = {},
  prevFilters = {},
}) => {
  const dispatch = useDispatch();
  const { loadingGTPTTrainers, gtptTrainerStats } = useSelector(
    (state) => state.api
  );

  const initialPtStatsData = {
    allData: null,
  };
  const [allPTDatas, setAllPTDatas] = useState(initialPtStatsData);
  const iniModValues = {
    isModOpen: false,
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const finalFilters = { ...prevFilters };
  finalFilters.type = "trainer_pt_status";

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const onClickStatCard = (name) => {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      modName: name,
    }));
  };

  function getTrainersStats(finalFilters) {
    if (finalFilters?.type) {
      dispatch(
        fetchGTPTtrainersStats({
          filters: finalFilters,
          token: userInfoData?.token,
        })
      );
    }
  }

  const sortedCards =
    allPTDatas.allData &&
    Object?.entries(allPTDatas.allData)
      ?.sort(([keyA], [keyB]) => {
        const indexA = PT_TRAINER_INFO_ORDER.indexOf(keyA);
        const indexB = PT_TRAINER_INFO_ORDER.indexOf(keyB);

        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      })
      ?.map(([key, value], index) => (
        <React.Fragment key={index}>
          <CommonStatCard
            tagName={key}
            cardLabel={getCardLabel(key)}
            value={getCardValue(key, value || 0)}
            icon={getCardIcon(key, loadingGTPTTrainers)}
            onClickCard={onClickStatCard}
          />
        </React.Fragment>
      ));

  useEffect(() => {
    getTrainersStats(finalFilters);
  }, [prevFilters]);

  useEffect(() => {
    setAllPTDatas((prevState) => {
      const newState = { ...prevState };

      if (gtptTrainerStats?.status && gtptTrainerStats?.data) {
        newState.allData = gtptTrainerStats.data;
      } else {
        newState.allData = null;
      }

      return newState;
    });
  }, [gtptTrainerStats]);

  return (
    <div className="flexCol">
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <ModalHeadAndClose
            title={`${getCardLabel(modValues.modName)}`}
            onClose={onCloseModal}
          />

          <PTFlowStatCardDetails
            userInfoData={userInfoData}
            clickedCard={modValues.modName}
            prevAllFilters={prevAllFilters}
          />
        </div>
      </Modal>

      <MealsStructure
        text={"PT Trainers Info"}
        isReload={() => getTrainersStats(finalFilters)}
      />

      <div className="cards-container cards-grid-container grid-5 pt-flow-new">
        {sortedCards}
      </div>
    </div>
  );
};

export default PTFlowTrainerInfoStats;
